import React from 'react';
import { DiffPayload } from './types';
interface Props {
  diff: DiffPayload;
}
export function RecordDiff({
  diff
}: Props) {
  if (diff.kind === 'fields') return <FieldDiff changes={diff.changes} data-id="element-2004" />;
  return <ProseDiff before={diff.before} after={diff.after} data-id="element-2005" />;
}
function FieldDiff({
  changes
}: {
  changes: {
    label: string;
    before: string;
    after: string;
  }[];
}) {
  return <div className="bg-[#0d1117] rounded-[12px] overflow-hidden border border-white/[0.06]" data-id="element-2006">
      <div className="grid grid-cols-2 text-[11px] uppercase tracking-wider text-[#8a8680]/60 bg-[#161b22] border-b border-white/[0.06]" data-id="element-2007">
        <div className="px-4 py-2" data-id="element-2008">Before</div>
        <div className="px-4 py-2 border-l border-white/[0.06]" data-id="element-2009">After</div>
      </div>
      {changes.map((c, i) => <div key={i} className="grid grid-cols-2 text-[13px] border-b border-white/[0.04] last:border-b-0" data-id="element-2010">
          <div className="px-4 py-3 bg-[#2d1215]/40" data-id="element-2011">
            <div className="text-[11px] text-[#8a8680]/60 mb-1" data-id="element-2012">{c.label}</div>
            <div className="text-[#f47067]" data-id="element-2013">{c.before}</div>
          </div>
          <div className="px-4 py-3 bg-[#12261e]/40 border-l border-white/[0.06]" data-id="element-2014">
            <div className="text-[11px] text-[#8a8680]/60 mb-1" data-id="element-2015">{c.label}</div>
            <div className="text-[#7ee787]" data-id="element-2016">{c.after}</div>
          </div>
        </div>)}
    </div>;
}
function ProseDiff({
  before,
  after
}: {
  before: string;
  after: string;
}) {
  const beforeLines = before.split('\n');
  const afterLines = after.split('\n');
  return <div className="bg-[#0d1117] rounded-[12px] overflow-hidden border border-white/[0.06] font-mono text-[12px] leading-relaxed" data-id="element-2017">
      <div className="grid grid-cols-2 text-[11px] uppercase tracking-wider text-[#8a8680]/60 bg-[#161b22] border-b border-white/[0.06]" data-id="element-2018">
        <div className="px-4 py-2" data-id="element-2019">Before</div>
        <div className="px-4 py-2 border-l border-white/[0.06]" data-id="element-2020">After</div>
      </div>
      <div className="grid grid-cols-2" data-id="element-2021">
        <div className="border-r border-white/[0.06]" data-id="element-2022">
          {beforeLines.map((line, i) => {
          const changed = afterLines[i] !== line;
          return <div key={i} className={`px-4 py-0.5 whitespace-pre-wrap ${changed ? 'bg-[#2d1215]/60 text-[#f47067]' : 'text-[#8b949e]'}`} data-id="element-2023">
                {line || ' '}
              </div>;
        })}
        </div>
        <div data-id="element-2024">
          {afterLines.map((line, i) => {
          const changed = beforeLines[i] !== line;
          return <div key={i} className={`px-4 py-0.5 whitespace-pre-wrap ${changed ? 'bg-[#12261e]/60 text-[#7ee787]' : 'text-[#8b949e]'}`} data-id="element-2025">
                {line || ' '}
              </div>;
        })}
        </div>
      </div>
    </div>;
}